import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplacePurchaseConfirmationComponent } from './marketplace-purchase-confirmation.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

@NgModule({
  declarations: [MarketplacePurchaseConfirmationComponent],
  imports: [
    CommonModule,
    PipesModule,
    DirectivesModule,
    FGBSharedModule
  ],
  exports: [MarketplacePurchaseConfirmationComponent],
})
export class MarketplacePurchaseConfirmationModule {}
